import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        const res = await api.post("/auth/session", null, {
          headers: { "X-Session-ID": sessionId },
        });
        setUser(res.data.user);
        window.history.replaceState(null, "", "/dashboard");
        const dest = res.data.user.onboarding_complete === false && res.data.user.role !== "admin" ? "/onboarding" : "/dashboard";
        navigate(dest, { replace: true, state: { user: res.data.user } });
        toast.success(`Welcome, ${res.data.user.name.split(" ")[0]}`);
      } catch (e) {
        toast.error("Sign-in failed. Please try again.");
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-[70vh] flex items-center justify-center">
      <div className="text-slate-400 font-mono text-xs uppercase tracking-widest">
        Establishing secure session…
      </div>
    </div>
  );
}
